'use client';

import type { FC } from 'react';

import { ScrollTopButton } from '@packages/modules/src/ScrollTopButton/ScrollTopButton';

/**
 * Scroll to top button for search pages (MBA, SERP and ZeroResultsPage)
 * */
export const SearchScrollTopButton: FC = () => (
  <div className="scroll-to-top-button z-app-bar fixed right-[2%] bottom-2">
    <ScrollTopButton />
  </div>
);
